import Configurator from './util/configurator';
import $ from 'jquery';
import kampaConfiguratorData from 'kampaConfiguratorData';

const form = $('#configurator-form');
const submitButton = $('#configurator-submit-button');

let fixedSlant = null;

let Config = new Configurator(kampaConfiguratorData);
if($('#height').length){
	if($('#height').length){
		Config.hasDifferentHeights = false;
	}
}

/**
 * Init
 */
init();
function init(){
	Config.init(document.getElementById('configurator-container'));
	updateSizes();
	handleFabrics();
	handleColors();
	handleEdgeMoreVisibility();
	handleCenterMoreVisibility();
	handleEyeletsCenter();
	handleCutsButtonView();
	handleCuts();
	handleDoor();
	handleEdges();
	handleWindowsButtonView();
	updateWindowsTabs();
	handleWindows();
	handleRail();
	handleCurtainExtras();
	handleExtras();
	handleForm();
}

window.addEventListener('resize',function(){
	Config = new Configurator(kampaConfiguratorData);
	init();
});

/**
 * Dimensions
 */


$('#width').change(updateSizes);
$('#height').change(updateSizes);
$('#height_left').change(updateSizes);
$('#height_right').change(updateSizes);
$('#slant').change(updateSizes);
function updateSizes(){
	let width = parseInt( $('#width').val() );
	let heightLeft = 0;
	let heightRight = 0;
	let slantRow = $('#slant-row');
	let slant = fixedSlant != null ? fixedSlant : $('#slant').val();

	if($('#height').length){
		let height = parseInt( $('#height').val() );
		heightLeft = height;
		heightRight = height;
	}
	else{
		heightLeft = parseInt( $('#height_left').val() );
		heightRight = parseInt( $('#height_right').val() );
	}

	if(heightLeft != heightRight && fixedSlant == null) slantRow.show();
	else slantRow.hide();

	Config.setTarpSize(width*10, heightLeft*10, heightRight*10, slant);
}


/**
 * Fabrics
 */
$('.fabric-field').change(handleFabrics);
function handleFabrics(){
	let selected = $('.fabric-field:checked');
	let fabric = selected.val();
	let productId = selected.data('product_id');
	let url = selected.data('url');
	let colorFields = $('.configurator-colors .color-field.'+fabric);

	form.attr('action',url);
	submitButton.attr('value',productId);

	$('.configurator-fabrics .fabric-info').removeClass('active');
	$('.configurator-fabrics .fabric-info.'+fabric).addClass('active');
	$('.configurator-header__close').attr('href',url);
	$('.configurator-colors .color-field').removeClass('active');
	colorFields.addClass('active');

	$('.configurator-colors__pattern-link').removeClass('active');
	$('#pattern-link-'+fabric).addClass('active');

	if(colorFields.find('.color-input:checked').length === 0){

		let colorField = colorFields.find('.color-input').first()
		colorField.prop('checked',true);
		colorField.trigger('change');
	}
}


/**
 * Colors
 */
$('.color-input').change(handleColors);
function handleColors(){
	let selected = $('.color-input:checked');
	let color = selected.data('hex');
	Config.setTarpColor(color);
}


/**
 * Edges
 */
function handleEdgeMoreVisibility(){
	if( $('.configurator-edge__field:hidden').length ){
		let fields = $('.configurator-edge__field:hidden');
		let parents = fields.parents('.configurator-edge');
		let more = parents.find('.configurator-edge__more');
		more.show();
	}
}

$('.configurator-edge__more-btn').click(function(e){
	let parent = $(this).parents('.configurator-edge');
	parent.toggleClass('all');
});

$('.edge-field').change(handleEdges);
$('.edge-space-field').change(handleEdges);
function handleEdges(){
	let extrasWithSpace = ['round','oval','oval_small','rotating_lock','plastic_rotating_lock','rotating_lock_small','roll','circle'];
	$('.edge-field:checked').each(function(i,el){
		let side = $(el).data('context');
		let value = $(el).val();
		let space = parseInt($('#edge-space-'+side).val()) * 10;
		let parents =  $(el).parents('.configurator-edge')
		let spaceOptions = parents.find('.edge-space-options');
		let selectedInfo = parents.find('.configurator-selected-info');
		let title = $(el).data('title');
		let tip = $(el).data('tip');
		let tipButton = selectedInfo.find('.configurator-selected-info__button');
		tipButton.hide();
		selectedInfo.find('.configurator-selected-info__text').html(title);

		if(tip){
			tipButton.data('id',tip);
			tipButton.show();
		}

		if(extrasWithSpace.includes(value)){
			spaceOptions.show();
		}
		else{
			spaceOptions.hide();
		}

		if(space >= 200){
			Config.setSides(side, value, space);
		}
	});

	Config.updateSidesExtras();
}

/**
 * Center
 */
function handleCenterMoreVisibility(){
	if( $('.configurator-center__field:hidden').length ){
		let fields = $('.configurator-center__field:hidden');
		let parents = fields.parents('.configurator-center');
		let more = parents.find('.configurator-center__more');
		more.show();
	}
}
$('.configurator-center__more-btn').click(function(e){
	let parent = $(this).parents('.configurator-center');
	parent.toggleClass('all');
});

$('.eyelets-center-field').change(handleEyeletsCenter);
$('#eyelets-center-space').change(handleEyeletsCenter);
$('#eyelets-center-offset').change(handleEyeletsCenter);
function handleEyeletsCenter(){
	let field = $('.eyelets-center-field:checked');
	let value = field.val();
	let space = parseInt($('#eyelets-center-space').val()) * 10;
	let offset = parseInt($('#eyelets-center-offset').val()) * 10;
	let options = $('.configurator-center__options');
	let selectedInfo = $('.configurator-center .configurator-selected-info');
	let title = field.data('title');
	let tip = field.data('tip');
	let tipButton = selectedInfo.find('.configurator-selected-info__button');
	tipButton.hide();
	selectedInfo.find('.configurator-selected-info__text').html(title);

	if(tip){
		tipButton.data('id',tip);
		tipButton.show();
	}

	if(value != 'none'){
		options.show();
	}
	else{
		options.hide();
	}

	if(space >= 200 && offset >= 200){
		Config.setEyeletsCenter(value, space, offset);
		Config.updateEyeletsCenter();
	}
}

/**
 * Door
 */
$('#configurator-add-door-button').click(function(e){
	e.preventDefault();
	$('#door').val(1);
	$('#door').trigger('change');
	handleDoor();
});

$('#configurator-delete-door-button').click(function(e){
	e.preventDefault();
	$('#door').val(0);
	$('#door').trigger('change');
	handleDoor();
});

$('.configurator-door-dimension-field').change(handleDoor);
$('#door_window').change(handleDoor);
function handleDoor(){
	let buttonWrap = $('.configurator-door__button-wrap');
	let doorOptions = $('#door-options');
	let doorWindowOptions = $('#door-window-options');

	if($('#door').val() == 1){
		buttonWrap.hide();
		doorOptions.slideDown();
		let doorWindow = $('#door_window').is(':checked');

		if(doorWindow){
			doorWindowOptions.slideDown();
		}
		else{
			doorWindowOptions.slideUp();
		}

		let doorWidth = parseInt($('#door_width').val()) * 10;
		let doorHeight = parseInt($('#door_height').val()) * 10;
		let doorOffset = parseInt($('#door_offset_left').val()) * 10;
		let doorWindowHeight = parseInt($('#door_window_height').val()) * 10;

		Config.addDoor(doorWidth, doorHeight, doorOffset, doorWindow, doorWindowHeight);
	}
	else{
		buttonWrap.show();
		doorOptions.slideUp();
		Config.deleteDoor();
	}
}

window.addEventListener(
	'configurator_door_moved',
	function(e){
		$('#door_offset_left').val(Math.round(e.detail.offset/10));
		form.trigger('change');
	},
	false
);


/**
 * Windows
 */
let windowsLimit = 4;
$('#configurator-add-window-button').click(function(e){
	e.preventDefault();
	let tabs = $('#windows-options .configurator-tab');
	let windowsCount = tabs.length;

	if(windowsCount < windowsLimit){
		tabs.removeClass('active');
		tabs.find('.configurator-tab__content').slideUp();
		let copyEl = $('#window-options-copy').clone(true);

		var re = new RegExp('{index}','g');
		var reName = new RegExp('__name','g');
		let uid = Date.now().toString(36) + Math.random().toString(36).substr(2);
		copyEl.html( copyEl.html().replace(re,uid).replace(reName,'name') );

		$('#windows-options').append(copyEl.html());

		updateWindowsTabs();
		handleWindows();
	}

	handleWindowsButtonView();
});

function updateWindowsTabs(){
	let tabs = $('#windows-options .configurator-windows__tab');
	tabs.each(function(i,el){
		var re = new RegExp('{number}','g');
		let tab = $(el);
		let titleEl = tab.find('.configurator-tab__title');
		let titlePattern = titleEl.data('title');
		titleEl.html(titlePattern.replace(re,i+1));
	});
	form.trigger('change');
}

function handleWindowsButtonView(){
	let tabs = $('#windows-options .configurator-windows__tab');
	let windowsCount = tabs.length;
	let buttonWrap = $('.configurator-windows__button-wrap');

	if(windowsCount >= windowsLimit){
		buttonWrap.hide();
	}
	else{
		buttonWrap.show();
	}
}

$(document).on('click', '.configurator-windows__delete-button', function(e){
	e.preventDefault();
	let tab = $(this).parents('.configurator-windows__tab');
	let uid = $(this).data('uid');
	tab.remove();

	Config.deleteWindow(uid);
	handleWindowsButtonView();
	updateWindowsTabs();
});

$(document).on('change', '.configurator-window-option-field', handleWindows);
function handleWindows(){
	$('#windows-options .configurator-windows__tab').each(function(i,el){
		let uid = $(el).find('.configurator-tab__header').data('uid');
		let windowType = $(el).find('.window_type').val();
		let windowWidth = parseInt( $(el).find('.window_width').val() ) * 10;
		let windowHeight = parseInt( $(el).find('.window_height').val() ) * 10;
		let windowOffsetLeft = parseInt( $(el).find('.window_offset_left').val() ) * 10;
		let windowOffsetBottom = parseInt( $(el).find('.window_offset_bottom').val() ) * 10;

		Config.addWindow(uid, windowWidth, windowHeight, windowOffsetLeft, windowOffsetBottom, windowType);
	});
}

window.addEventListener(
	'configurator_window_moved',
	function(e){
		$('input[name="windows['+e.detail.uid+'][window_offset_left]"').val(Math.round(e.detail.offsetLeft/10));
		$('input[name="windows['+e.detail.uid+'][window_offset_bottom]"').val(Math.round(e.detail.offsetBottom/10));
		form.trigger('change');
	},
	false
);

/**
 * Cuts
 */
let cutsLimit = 4;
//updateCutsTabs();

$('#configurator-add-cut-button').click(function(e){
	e.preventDefault();
	let tabs = $('#cuts-options .configurator-tab');
	let cutsCount = tabs.length;

	if(cutsCount < cutsLimit){
		tabs.removeClass('active');
		tabs.find('.configurator-tab__content').slideUp();
		let copyEl = $('#cut-options-copy').clone(true);

		var re = new RegExp('{index}','g');
		var reName = new RegExp('__name','g');
		let uid = Date.now().toString(36) + Math.random().toString(36).substr(2);
		copyEl.html( copyEl.html().replace(re,uid).replace(reName,'name') );

		$('#cuts-options').append(copyEl.html());

		updateCutsTabs();
		handleCuts();
	}

	handleCutsButtonView();
});

function updateCutsTabs(){
	let usedCorners = getUsedCutsCorners();
	let tabs = $('#cuts-options .configurator-cuts__tab');
	tabs.each(function(i,el){
		var re = new RegExp('{number}','g');
		let tab = $(el);
		let titleEl = tab.find('.configurator-tab__title');
		let titlePattern = titleEl.data('title');
		titleEl.html(titlePattern.replace(re,i+1));

		$(el).find('.cut_corner option').each(function(iO,elO){
			let option = $(elO);
			let value = option.val();
			option.hide();
			if(usedCorners.indexOf(value) == -1 && value != ''){
				option.show();
			}
		});
	});
	form.trigger('change');
}

function getUsedCutsCorners(){
	let usedCorners = [];
	let tabs = $('#cuts-options .configurator-cuts__tab');
	tabs.each(function(i,el){
		let cutCorner = $(el).find('.cut_corner').val();
		usedCorners.push(cutCorner);
	});
	return usedCorners;
}

function handleCutsButtonView(){
	let tabs = $('#cuts-options .configurator-cuts__tab');
	let cutsCount = tabs.length;
	let buttonWrap = $('.configurator-cuts__button-wrap');

	if(cutsCount >= cutsLimit){
		buttonWrap.hide();
	}
	else{
		buttonWrap.show();
	}
}

$(document).on('click', '.configurator-cuts__delete-button', function(e){
	e.preventDefault();
	let tab = $(this).parents('.configurator-cuts__tab');
	let uid = $(this).data('uid');
	tab.remove();

	Config.deleteCut(uid);
	handleCutsButtonView();
	updateCutsTabs();
});

$(document).on('change', '.configurator-cut-option-field', handleCuts);
function handleCuts(update = true){
	$('#cuts-options .configurator-cuts__tab').each(function(i,el){
		let uid = $(el).find('.configurator-tab__header').data('uid');
		let cutCorner = $(el).find('.cut_corner').val();
		let cutWidth = parseInt( $(el).find('.cut_width').val() ) * 10;
		let cutHeight = parseInt( $(el).find('.cut_height').val() ) * 10;

		updateCutsTabs();
		Config.addCut(uid, cutWidth, cutHeight, cutCorner, false);
	});

	if(update){
		Config.updateSidesExtras();
	}
}

/**
 * Extras
 */
$('input[name=dirt_lap]').change(handleDirtLapExtras);
$('input[name=roll_belts]').change(handleRollBeltsExtras);
$('input[name=steel_rope]').change(handleSteelRopeExtras);

function handleExtras(){
	handleDirtLapExtras();
	handleRollBeltsExtras();
	handleSteelRopeExtras();
}

function handleDirtLapExtras(){
	if($('input[name=dirt_lap]').is(':checked')){
		Config.addDirtLap();
	}
	else{
		Config.removeDirtLap();
	}
}

function handleRollBeltsExtras(){
	if($('input[name=roll_belts]').is(':checked')){
		Config.addRollBelts();
	}
	else{
		Config.removeRollBelts();
	}
}

function handleSteelRopeExtras(){
	if($('.edge-field-top:checked').val() == 'circle' && $('input[name=steel_rope').is(':checked')){
		Config.addSteelRope();
	}
	else{
		Config.removeSteelRope();
	}
}

/**
 * Curtain
 */
$('.edge-field-top').change(handleCurtainExtras);
function handleCurtainExtras(){
	let val = $('.edge-field-top:checked').val();
	let steelRopeCol = $('#steel_rope_col');
	let railSection = $('#rail_section');

	steelRopeCol.hide();
	railSection.hide();

	if(val == 'circle'){
		steelRopeCol.show();
		fixedSlant = 'bottom';
	}
	else if(val == 'roll'){
		railSection.show();
		fixedSlant = 'bottom';
	}
	else{
		fixedSlant = null;
	}

	updateSizes();
	handleExtras();
}

$('#configurator-add-rail-button').click(function(e){
	e.preventDefault();
	$('#rail').val(1);
	$('#rail').trigger('change');
	handleRail();
});

$('#configurator-delete-rail-button').click(function(e){
	e.preventDefault();
	$('#rail').val(0);
	$('#rail').trigger('change');
	handleRail();
});

$('#rail_extra_length').change(handleRail);
$('#rail_bow').change(handleRail);
$('input[name=holders]').change(handleRail);
$('#rail_curved').change(handleRail);
function handleRail(){
	let buttonWrap = $('.configurator-rail__button-wrap');
	let railOptions = $('#rail-options');
	let holdersSection = $('#holders_section');
	let holdersField = $('input[name=holders]:checked');
	let holders = holdersField.val();

	let selectedInfo = $('#holders_section .configurator-selected-info');
	let title = holdersField.data('title');
	let tip = holdersField.data('tip');
	let tipButton = selectedInfo.find('.configurator-selected-info__button');
	tipButton.hide();
	selectedInfo.find('.configurator-selected-info__text').html(title);

	if(tip){
		tipButton.data('id',tip);
		tipButton.show();
	}

	if($('.edge-field-top:checked').val() == 'roll' && $('#rail').val() == 1){
		buttonWrap.hide();
		railOptions.slideDown();
		let railExtraLength = parseInt($('#rail_extra_length').val());
		let railCurvedLengthRow = $('#rail_curved_length_row');
		let railCurved = $('#rail_curved').is(':checked');

		if(railCurved){
			railCurvedLengthRow.show();
		}
		else{
			railCurvedLengthRow.hide();
		}

		holdersSection.show();
		Config.setRail(holders, railExtraLength*10, railCurved);
	}
	else{
		buttonWrap.show();
		railOptions.slideUp();
		Config.removeRail();
		holdersSection.hide();
	}
}

/**
 * Tabs
 */
$('.configurator-tab.active .configurator-tab__content').slideDown();

$(document).on('click', '.configurator-tab__arrow', function(e){
	e.preventDefault();
	let tab = $(this).parents('.configurator-tab');
	let tabContent = tab.find('.configurator-tab__content');
	tabContent.slideToggle();
	tab.toggleClass('active');
});

$(document).on('click', '.configurator-tab__header', function(e){
	e.preventDefault();
	if(e.target == this){
		let tab = $(this).parents('.configurator-tab');
		let tabContent = tab.find('.configurator-tab__content');
		tabContent.slideDown();
		tab.addClass('active');
	}
});


/**
 * Errors
 */
window.addEventListener(
	'configurator_errors_update',
	handleConfiguratorErrors,
	false
);
function handleConfiguratorErrors(){
	let errors = Config.getErrors();
	$('.configurator-error').hide();

	if(errors.length){
		disableForm();
		errors.forEach(function(key){
			$('#configurator-error-'+key).show();
		});
	}
	else{
		enableForm();
	}
}

/**
 * Events
 */
window.addEventListener('configurator_dimension_click',function(e){
	let id = e.detail.name;
	let field = $('#'+id);
	let heightField = $('#height');

	if(heightField.length && (id == 'height_left' || id == 'height_right')){
		field = heightField;
	}

	field.focus();
	field.select();
},false);

/**
 * Form
 */
let doingProductFormAjax = false;
let productFormData = null;

form.change(handleForm);
form.on('keyup keypress', function(e) {
	var keyCode = e.keyCode || e.which;
	if (keyCode === 13) {
		e.preventDefault();
		return false;
	}
});
function handleForm() {
	productFormData = new FormData(form[0]);
	doProductFormAjax();
}

function doProductFormAjax(){

	if(productFormData === null || doingProductFormAjax) return;

	var formData = productFormData;
	formData.append('action','kampa_configurator_calculation');

	productFormData = null;
	doingProductFormAjax = true;

	disableForm();

	$.ajax({
		type: 'POST',
		url: kampa.ajax_url,
		data: formData,
		processData: false,
		contentType: false,
		success: function (res) {
			let data = JSON.parse(res);

			doingProductFormAjax = false;
			doProductFormAjax();

			$('.warning').html('');
			$('.field-warning').removeClass('field-warning');
			if(!data.validation.result){
				data.validation.warnings.forEach(function(e){
					let warningEl = $('#warning-' + e.key);
					warningEl.html(e.msg);
					$('#' + warningEl.data('field')).addClass('field-warning');
				});
			}
			else {
				$('.configurator-price').html(data.price_html);
				enableForm();
			}


			handleConfiguratorErrors();
		},
	});
}

function disableForm(){
	$('.configurator-price').html('<i class="fas fa-spinner fa-spin spinner"></i>');
	submitButton.attr('disabled',true);
}

function enableForm(){
	submitButton.attr('disabled',false);
}

/**
 * Mobile
 */
$('#configurator-preview-button').click(function(e){
	e.preventDefault();
	$('.configurator-page__image').addClass('active');
});

$('#configurator-preview-close-button').click(function(e){
	e.preventDefault();
	$('.configurator-page__image').removeClass('active');
});



// WEBPACK FOOTER //
// ./scripts/configurator.js